import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import props from '../../../../redux/props'
import OfferEntryList from './OfferEntryList/OfferEntryList'
import Checkbox from '../../../UI/Checkbox/Checkbox'
import useLoadControllingYearReport from '../../../hooks/Controlling/useLoadControllingYearReport'
import Facts from './Facts'
import QuarterCharts from './QuarterCharts'

const Forecast: React.FC<{}> = () => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const [onlyAcceptedOfferEntries, setOnlyAcceptedOfferEntries] = useState(false)
  const [yearReport, pull] = useLoadControllingYearReport()

  const getEntries = () => {
    return onlyAcceptedOfferEntries ? yearReport.entries.filter((entry) => entry.accepted) : yearReport.entries
  }

  return (
    <div>
      <Checkbox
        label={t.controlling.forecast.onlyAcceptedOfferEntries}
        checked={onlyAcceptedOfferEntries}
        onChange={() => setOnlyAcceptedOfferEntries(!onlyAcceptedOfferEntries)}
      />
      <div className="flex flex-col gap-5 my-10">
        <Facts entries={getEntries()} previousYearEntries={yearReport.previousYearEntries} />
        <QuarterCharts entries={getEntries()} />
      </div>
      <OfferEntryList offerEntries={getEntries()} pull={pull} />
    </div>
  )
}

export default Forecast
